import { Check } from 'lucide-react';

export const PlanFeatures = ({ features }: { features: string[] }) => (
  <ul className='mt-[26px] grid gap-3'>
    {features.map((feature, i) => (
      <li key={i} className='flex gap-3 leading-[1.35] text-ob-text-secondary'>
        <Check className='mt-[0.18em] h-4 w-4 shrink-0 text-ob-focus' strokeWidth={1.5} aria-hidden />
        <span>{feature}</span>
      </li>
    ))}
  </ul>
);
